<template>
  <div class="CharacterContainer" :class="{ SpaceAround: spaceAround }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {};
  },
  props: {
    spaceAround: {
      type: Boolean,
      default: false,
    },
  },
  created () {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.CharacterContainer {
  display: inline;
}
.SpaceAround {
  display: flex;
  justify-content: space-around;
}
</style>
